import { DefaultLayout } from '@c/layouts';
import SafeImage from '@ui/SafeImage';
import Script from 'next/script';
import React from 'react';
import { NextSeo } from 'next-seo';

import basicImg from '@public/promos/package/basic.png';
import silverImg from '@public/promos/package/silver.png';
import goldImg from '@public/promos/package/gold.png';
import videoImg from '@public/promos/package/video.png';

const IMAGE_ALT_TEXT = {
  basic: `Basic Package, Email Ad Placement, 40 thousand subscribers, 40% open rate, 2% click through rate. Above the fold ad placement. 3 sends.`,
  silver: `Silver Package. Includes basic Package plus dedicated email. 3 above the fold placements 2nd block in email. 1 fully dedicated email.`,
  gold: `Includes silver package plus banner ads. 1 homepage banner ad and 1 blog banner ad.`,
  video: `Sponsorship within the first 30 seconds of the video. 19k youtube subscribers. 6.7k facebook followers. 2.5k twitter followers. 6.3k instagram followers. 1 mention in video, link in bio.`,
};

const Advertising = () => {
  return (
    <>
      <NextSeo
        title="Advertise on GearFocus - Reach 40,000+ Creators"
        description="Promote your brand to an engaged audience of photographers, filmmakers, and content creators. Explore email, banner, and video sponsorship packages on GearFocus."
        openGraph={{
          images: [
            {
              url: "https://gearfocus.com/gear_pile.png",
              width: 800,
              height: 600,
              alt: "Advertise on GearFocus Marketplace",
              type: "image/jpeg",
            },
          ],
          siteName: "GearFocus Marketplace",
          type: 'website',
          url: "https://gearfocus.com/advertising",
        }}
      />
      <div className="mx-auto flex w-full flex-col items-center  justify-evenly overflow-x-hidden bg-[#1a243d] px-4 py-[3.2rem] text-white lg:h-screen lg:px-0">
        <div className="max-w-[70rem] text-center ">
          <h1 className="mb-[1.6rem] text-[3.2rem] font-bold">
            Advertising on GearFocus
          </h1>
          <span className=" text-[1.6rem] font-semibold">
            Embrace the opportunity to directly reach an engaged audience of
            over 40,000 creators on GearFocus Marketplace. By advertising with
            us, your brand will capture the attention of passionate
            photographers, filmmakers, podcasters, vloggers, and other creative
            professionals who constantly seek the latest and greatest in gear.
            Our users are not just casual hobbyists—they are invested, creators.
            Let us help you bring your products and services into the spotlight
            they deserve.
          </span>
        </div>
        <Script async src="https://js.stripe.com/v3/pricing-table.js"></Script>
        <span
          className="w-screen"
          dangerouslySetInnerHTML={{
            __html: `<stripe-pricing-table pricing-table-id="prctbl_1N6E1cHRcyniVqvhYakhCvWo"
      publishable-key="pk_live_51EzljoHRcyniVqvhIWGKYo3esZYOs3BWVrASua9GZpLYT6YealZ9e2IwDyntXvYBNsJRi0FWOJQwj1bLipqhbewf00XklS07Wl">
      </stripe-pricing-table>`,
          }}
        />
      </div>
      <div>
        <SafeImage
          src={basicImg.src}
          height={2800}
          width={1600}
          alt={IMAGE_ALT_TEXT['basic']}
        />
        <SafeImage
          src={silverImg.src}
          height={2800}
          width={1600}
          alt={IMAGE_ALT_TEXT['silver']}
        />
        <SafeImage
          src={goldImg.src}
          height={2800}
          width={1600}
          alt={IMAGE_ALT_TEXT['gold']}
        />
        <SafeImage
          src={videoImg.src}
          height={2800}
          width={1600}
          alt={IMAGE_ALT_TEXT['video']}
        />
      </div>
    </>
  );
};

Advertising.getLayout = function getLayout(page: React.ReactElement) {
  return <DefaultLayout>{page}</DefaultLayout>;
};

export default Advertising;
